'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSourceAttribution = getSourceAttribution;
exports.clearSourceAttribution = clearSourceAttribution;
exports.trackPreRegistrationPageVisit = trackPreRegistrationPageVisit;

var _dibsBrowserStorage = require('dibs-browser-storage');

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _dibsCookieJar = require('dibs-cookie-jar');

var _visitCountConstants = require('./visitCountConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MASQUERADE_BUYER = _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER;


function prepareTimeNr(number) {
    var num = Math.abs(Math.floor(number));
    return (num < 10 ? '0' : '') + num;
};

function getDateTime() {
    var now = new Date();
    var timezoneOffset = -now.getTimezoneOffset();
    var dif = timezoneOffset >= 0 ? '+' : '-';

    var date = now.getFullYear() + '-' + prepareTimeNr(now.getMonth() + 1) + '-' + prepareTimeNr(now.getDate()) + 'T' + prepareTimeNr(now.getHours()) + ':' + prepareTimeNr(now.getMinutes()) + ':' + prepareTimeNr(now.getSeconds()) + '.' + now.getMilliseconds() + dif + prepareTimeNr(timezoneOffset / 60) + ':' + prepareTimeNr(timezoneOffset % 60);

    return {
        date: date,
        time: now.getTime()
    };
};

function getSourceAttributionFromStorage() {
    return _dibsBrowserStorage2.default.localStorage.getItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT) || [];
};

function prepareSourceAttributionToSave(element) {
    delete element.time;
    return element;
};

function getSourceAttribution() {
    var sourceAttribution = getSourceAttributionFromStorage();
    return sourceAttribution.map(prepareSourceAttributionToSave);
};

function clearSourceAttribution() {
    _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT);
}

function trackPreRegistrationPageVisit(page) {
    if ((0, _dibsCookieJar.getUserId)(document.cookie, MASQUERADE_BUYER)) {
        return;
    }

    page = page || window.location.pathname;
    var sourceAttribution = getSourceAttributionFromStorage();
    var attributionElement = sourceAttribution.filter(function (_ref) {
        var landingPage = _ref.utmParams.landingPage;
        return landingPage === page;
    })[0];

    if (attributionElement) {
        attributionElement.utmParams.visitCount++;

        Object.assign(attributionElement, getDateTime());
    } else {
        var atribution = Object.assign(getDateTime(), {
            type: _visitCountConstants.TYPE_PRE_REGISTRATION_PAGE_VISIT,
            utmParams: {
                landingPage: page,
                visitCount: 1
            }
        });
        sourceAttribution.push(atribution);
    }

    sourceAttribution = sourceAttribution.sort(function (a, b) {
        if (a.time < b.time) {
            return 1;
        } else if (a.time > b.time) {
            return -1;
        }
        return 0;
    }).slice(0, _visitCountConstants.CAP_PRE_REGISTRATION_PAGE_VISIT);

    _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT, sourceAttribution);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-visit-tracking/dist/sourceAttribution.js
// module id = ./node_modules/dibs-visit-tracking/dist/sourceAttribution.js
// module chunks = 4